<div class="show-field">
  <div class="show-field__label">{{ label }}</div>
  <div class="show-field__value">
    <ng-content></ng-content>
  </div>
</div>
